<template>
    <div class="input-table">
        <div
          v-if="items.length"
          class="input-table-shadow"
        >
            <div class="d-flex row align-items-center">
                <div class="col-2 border-right">
                    <input class="pl-3" type="text" readonly="readonly" :value="frontEndDateFormat(fromDate)" />
                </div>
                <core-drop-down
                    class="col-3 border-right"
                    v-if="origin.length && origin[0]"
                    :items="origin"
                    v-model="selectedOriginStation"
                    :selectedValue.sync="selectedOriginStation"
                    noLabel
                    :key="originComponentKey"
                ></core-drop-down>
                <div class="col border-right">
                  <input type="text" readonly="readonly" :value="getOriginTime()" />
                </div>
                <core-drop-down
                    class="col-3 border-right"
                    v-if="selectedOriginStation && destination && destination[selectedOriginStation.id]"
                    :items="destination[selectedOriginStation.id]"
                    v-model="selectedDestinationStation"
                    :selectedValue.sync="selectedDestinationStation"
                    noLabel
                    :key="destinationComponentKey"
                ></core-drop-down>
                <div class="col border-right">
                  <input type="text" readonly="readonly" :value="getDestinationTime()" />
                </div>
                <div class="col">
                  <input type="text" readonly="readonly" :value="getNights" />
                </div>
            </div>
        </div>
        <div v-else>
            <small class="ml-2 px-2 bg-danger text-white">{{ $t('reservation.details.transport.no-times') }}</small>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    times: {
      type: Array,
      required: true
    },
    originStation: {
      default: null,
      type: Object,
      required: false
    },
    destinationStation: {
      default: null,
      type: Object,
      required: false
    },
    departureDate: {
      default: null,
      type: String,
      required: false
    },
    arrivalDate: {
      default: null,
      type: String,
      required: false
    }
  },
  data () {
    return {
      items: this.times,
      selectedOriginStation: this.originStation,
      selectedDestinationStation: this.destinationStation,
      origin: [],
      destination: {},
      fromDate: this.departureDate,
      untilDate: this.arrivalDate,
      originComponentKey: 1,
      destinationComponentKey: 2
    }
  },
  created () {
    if (this.items.length) {
      this.createOriginAndDestination()
    }
  },
  computed: {
    getNights () {
      let from = this.$moment(this.fromDate, 'YYYY-MM-DD')
      let until = this.$moment(this.untilDate, 'YYYY-MM-DD')
      return from.diff(until, 'days') + 1
    }
  },
  methods: {
    createOriginAndDestination () {
      this.items.forEach((item) => {
        // set origin stations
        if (!this.origin.find(s => s.id === item.stationOrigin.id)) {
          this.origin.push(item.stationOrigin)
        }
        // set destination stations
        if (this.destination[item.stationOrigin.id]) {
          // if the array is empty
          this.destination[item.stationOrigin.id].push(item.stationDestination)
        } else {
          // if the array contains elements
          this.destination[item.stationOrigin.id] = [item.stationDestination]
        }
      })
      if (!this.selectedOriginStation && this.origin.length) {
        this.selectedOriginStation = this.origin[0]
      }
      if (!this.selectedDestinationStation && this.destination && this.destination[this.selectedOriginStation.id] && this.destination[this.selectedOriginStation.id].length) {
        this.selectedDestinationStation = this.destination[this.selectedOriginStation.id][0]
      }
    },
    getOriginTime () {
      if (this.selectedOriginStation) {
        let originTime = null
        originTime = this.items.find((item) => {
          return item.stationOrigin.id === this.selectedOriginStation.id
        })
        if (originTime) {
          return this.$moment(originTime.originTime, 'HH:mm:ss').format('HH:mm')
        }
      }
    },
    getDestinationTime () {
      if (this.selectedDestinationStation) {
        let destinationTime = null
        destinationTime = this.items.find((item) => {
          return item.stationDestination.id === this.selectedDestinationStation.id
        })
        if (destinationTime) {
          return this.$moment(destinationTime.destinationTime, 'HH:mm:ss').format('HH:mm')
        }
      }
    },
    frontEndDateFormat (date) {
      if (!date) {
        return ''
      }
      return this.$moment(date, 'YYYY-MM-DD').format('DD/MM')
    }
  },
  watch: {
    selectedOriginStation (val) {
      this.$emit('update:originStation', val)
      this.selectedDestinationStation = this.destination[val.id][0]
      /**
       * The best way to rerender a component
       * @see https://michaelnthiessen.com/force-re-render/
       */
      this.originComponentKey += 2
    },
    selectedDestinationStation (val) {
      this.$emit('update:destinationStation', val)
      /**
       * The best way to rerender a component
       * @see https://michaelnthiessen.com/force-re-render/
       */
      this.destinationComponentKey += 2
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/FreeSaleTransportTime.vue